var map = {
	"./background_bar.PNG": 567,
	"./background_chai.PNG": 433,
	"./background_deployment.PNG": 143,
	"./background_edit.PNG": 606,
	"./background_home.jpg": 408,
	"./background_infostand.PNG": 440,
	"./background_kasse.PNG": 575,
	"./background_list.PNG": 218,
	"./background_login.PNG": 867,
	"./background_register.PNG": 281,
	"./background_ressort.PNG": 530,
	"./background_zero.PNG": 164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;